/* globals dataLayer, adobe */
(function(window, angular, undefined) {
angular.module('formApp')
.controller('stepFiveCtrl', ['$scope','$http', '$q', 'FormService', 'formData', '$state', 'moment', 'scrollToPoint', '$timeout', '$rootScope', '$sce', 'errorHandler', 'LoadingInterceptor', 'sessionService', 'dataLayerService',
'$window',function($scope, $http, $q, formService, formData, $state, moment, scrollToPoint, $timeout, $rootScope, $sce, errorHandler, loadingInterceptor, sessionService, dataLayerService,$window) {
    
    var mboxName = 'reviewPayStep5NewQB';
    $scope.__env = $window.__env;

    var evt = new CustomEvent("currentStep", {detail: {step:"5"}});
    window.dispatchEvent(evt);
    console.log('event dispatched',evt);

    // Additional excess wording vars
    $scope.essentialAddExcess = false;
    $scope.noAddExcess = false;
    var i;
    var products;
    
    sessionService.start();

    if (sessionStorage.getItem('retrieveQuote') === 'true'){
        $scope.hideEditLink = true;
    }
    // $scope.pet.payment = "";
    if (sessionStorage.getItem('journey') === 'combined'){
        $rootScope.mainJourney = false;
        $rootScope.journeyClass = 'combined';
    }

    if (sessionStorage.getItem('journey') === 'single'){
        $rootScope.mainJourney = true;
        $rootScope.journeyClass = 'single';
    }
    
    $scope.returnToPay = function(){
        scrollToPoint.scrollTo('howToPay',20,'id');
    };


        $rootScope.$on('charityInfo', function (event, args) {
        scrollToPoint.scrollTo('topOfTheApp', 20, 'id');
    });

    $rootScope.$on('cops-success', function (event, args) {
        goToConfirmation();
    });
        $rootScope.$on('cops-error', function (event, args) { 
        
        if(args.errortype === 'pop'){
            $scope.copsErrorPop = true;
            $scope.copsError = args.errorcode;
            $scope.paymentButtonDisabled = false;
            $scope.$apply();
        }

        // errorHandler.reportErrors(event,'redirect','cops',args);
    });
    
    if ($state.params.type === 'topNav') {
        var navMethod = $state.params.type;
    }

    if (sessionStorage.getItem('eQuote')) {
        sessionStorage.setItem('currentRefreshState', 'step-5e');
    } else if (sessionStorage.getItem('eCoverNote')) {                 
        sessionStorage.setItem('currentRefreshState', 'pay-ec');
        mboxName = 'reviewPayStep5Ecover';
    }
    else {
        sessionStorage.setItem('currentRefreshState', 'step-5');
    }

    $scope.$watch('gatewayReady', function () {
        if ($scope.gatewayReady === true && sessionStorage.getItem('formStateUri')) {
        
            formService.setApplicationId(sessionStorage.getItem('formStateUri'));
            if (sessionStorage.getItem('eQuote') !== 'true') {
                $rootScope.eQuote = false;
                sessionService.heartbeat();
            }

            loadingInterceptor.incrementRequests();
        

            refreshRunningTotals().then(function(rt){

                return refresh();
            })
            .then(function (response) {
            
                loadingInterceptor.decrementRequests();
                var eQuoteFlag = sessionStorage.getItem('eQuote');
                $rootScope.eQuote = eQuoteFlag;
                if (sessionStorage.getItem('eQuoteCn') || $rootScope.eCoverNote) {
                    $rootScope.eQuoteCoverNote = true && !$rootScope.eCoverNote;  
                    $rootScope.eQuoteCoverNoteEnd = moment(response.data.officeUseOnly.params.coverNoteEndDate,'DD/MM/YYYY').toDate();
                }
                $scope.formData.pets = response.data.application.pets;
                $scope.formData.cover = response.data.application.cover;
                $scope.formData.aboutYou = response.data.application.aboutYou;
                $scope.formData.charitableDonation = response.data.application.charitableDonation;
                $scope.formData.officeUseOnlyParams = response.data.officeUseOnly.params;
                // ADDED FOR EQ TANDT TEST//
                    if(window.charitySwitch && $scope.formData.charitableDonation == null){
                        $scope.formData.charitableDonation = {wishesToDonate : "N"};
                }
                // ADDED FOR EQ TANDT TEST//
                $scope.formData.products = response.data.products;
                $scope.formData.runningTotals = response.data.runningTotals;

                products = response.data.products;
                $scope.products = products;
                
                if (response.data.officeUseOnly.params && response.data.officeUseOnly.params.coverNoteEndDate) {
                    $scope.freeCoverExpired = moment(response.data.officeUseOnly.params.coverNoteEndDate, 'DD/MM/YYYY').startOf('day').diff(moment().startOf('day'), 'days') < 0;
                }
                
                $scope.freeCoverFirstMonth = moment($scope.formData.cover.startDate, 'YYYY-MM-DD').format('MMMM');
                $scope.freeCoverSecondMonth = moment($scope.formData.cover.startDate, 'YYYY-MM-DD').add(1, 'month').format('MMMM');
                $scope.freeCoverThirdMonth = moment($scope.formData.cover.startDate, 'YYYY-MM-DD').add(2, 'month').format('MMMM');

                $scope.iddExcessStatement = response.data.iddExcessStatement;
                
                var pc = $scope.formData.aboutYou.postCode;

                dataLayer.push({
                    'event' : 'dataAvailable',
                    'funnelName':  parseInt(dataLayerService.setFunnelName()),
                    'funnelVersion':  dataLayerService.setFunnel(), 
                    'funnelPageNumber': 5,
                    'funnelSfc': sessionStorage.getItem('eCoverJourney') === 'recognised' || sessionStorage.getItem('eCoverJourney') === 'return-rec',
                    'funnelFc': sessionStorage.getItem('eCoverJourney') === 'retrieveQB',
                    'funnelFcRtn': sessionStorage.getItem('eCoverJourney') === 'return' || sessionStorage.getItem('eCoverJourney') === 'return-rec',
                    'numberOfPets': $scope.formData.pets.length,
                    'multipetFlag': dataLayerService.multiPetTest($scope.formData.pets.length),
                    'petDetailsPosition': 1,
                    'environment': window.location.hostname,
                    'bravCode': '',
                    'campaignCode':dataLayerService.campaignCode(),
                    'partnerName': dataLayerService.partnerName(),
                    'postcode': pc.split(" ", 1).toString(),
                    'quoteId': $window.sessionStorage.getItem('formStateUri'),
                    'policyVariables': $rootScope.gaquoteVariables,
                    'quoteRetrieval':dataLayerService.setRetrieveMode(),
                    "eQuoteFlag": sessionStorage.getItem('eQuote'),
                });
                $scope.pushPet = function(){
                    dataLayer.push({
                        'event': 'paymentSubmit',
                        'coverStartDate': $scope.formData.cover.startDate,
                        'numberOfPets': $scope.formData.pets.length,
                        'multipetFlag': dataLayerService.multiPetTest($scope.formData.pets.length),
                        'monthlyCost': $rootScope.gaPetData.monthlyTotal,
                        'deathIllnessCost': dataLayerService.ifDeathIllness(),
                        'paymentFrequency': dataLayerService.paymentFreq($scope.pet.payment),
                        'paymentType': dataLayerService.paymentType($scope.pet.payment),
                        'paymentMonths': 12,
                        'paymentTotal':  $rootScope.gaPetData.total,
                        'postcode': pc.split(" ", 1).toString(),
                        'quoteId': $window.sessionStorage.getItem('formStateUri'),
                        'policyVariables': $rootScope.gaquoteVariables,
                        'quoteRetrieval':dataLayerService.setRetrieveMode(),
                        "eQuoteFlag": sessionStorage.getItem('eQuote'),
                    });
                };

                if(window.sessionCamRecorder) {
                    if(window.sessionCamRecorder.createVirtualPageLoad) {
                        window.sessionCamRecorder.createVirtualPageLoad('stepFive');
                    }
                }

                // Check if pets have Essential plan for additional excess wording
                for(i = 0; i < $scope.formData.pets.length; i++){
                    if(formData.pets[i].chosenCover.productLine === 'Essential') {
                        // If older dog or approaching year before older limit this wording does not apply
                        if(formData.pets[i].type === 'dog' && formData.pets[i].details.agesInYearsAtCoverStart >= 7) {
                            $scope.noAddExcess = true;
                        }
                        // If dog and select breed aged 4 and above do not show
                        else if(formData.pets[i].type === 'dog' && formData.runningTotals.products[i].selectBreed === 'true' && formData.pets[i].details.agesInYearsAtCoverStart >= 4) {
                            $scope.noAddExcess = true;
                        }
                        // If older cat or approaching year before older limit this wording does not apply
                        else if(formData.pets[i].type === 'cat' && formData.pets[i].details.agesInYearsAtCoverStart >= 9) {
                            $scope.noAddExcess = true;
                        }
                        else {
                            $scope.essentialAddExcess = true;
                        }
                    }                 
                }

                // update totals and excess
                $scope.$broadcast('updateSummary');
            }).catch(function(error) {
                errorHandler.reportErrors(error,'redirect','tech');
            });
        }
        function refresh() {
                return formService.getSummary();
        }
        function refreshRunningTotals() {
            return formService.getRunningTotals();
        }
    }); 

    var promises = [];

    // Set up the prefilled 
    $scope.accountHolderNameCC = formData.aboutYou.title + formData.aboutYou.firstName + formData.aboutYou.lastName;
    $scope.registeredAddressCC = 
        formData.aboutYou.houseNameOrNumber + "<br />" +
        formData.aboutYou.street + "<br />" +
        formData.aboutYou.town + "<br />" +
        formData.aboutYou.county + "<br />" + 
        formData.aboutYou.postCode;

    $scope.mDate = moment;
    $scope.parseInt = parseFloat;
    $scope.formData = formData;
    $scope.loading = false;


    $scope.getParisBreed = function(pet) {
        var breed = '';
        angular.forEach(pet.cc, function(prod) {
            if (pet.chosenCover && pet.chosenCover.productId === prod.id && pet.uri === prod.pet) {
            
                if(prod.parisBreedTwo !== 'Unknown' && pet.details.type === 'MultiBreed' && pet.type ==='dog'){
                    breed = prod.parisBreed+' and '+prod.parisBreedTwo + ' cross';  
                }
                else if(prod.parisBreedTwo === 'Unknown' && pet.details.type === 'MultiBreed' && pet.type ==='dog'){
                    breed = prod.parisBreed+' cross'; 
                }
                else{
                    breed = prod.parisBreed;    
                }

            }
        });
        return breed;
    };

    $scope.focusMe = function (elm){
        document.getElementById(elm).focus();
    };

    $scope.submit = function(e,ptype) {
        loadingInterceptor.incrementRequests();
        submitMarketing().then(function success(data, status) {
            loadingInterceptor.decrementRequests();
            processPayment(ptype);
        }, function failure(e) {
            errorHandler.reportErrors(e,'redirect','tech');
        });
    };

    function submitMarketing() {
        if($scope.schema.application.postPolicyMarketing) {
            return formService.postPostPolicyMarketing($scope.formData.postPolicyMarketing);
        } else {
            var deferred = $q.defer();
            deferred.resolve();
            return deferred.promise;
        }
    }

    $scope.$watch('pet.payment.annualPaymentMethod', function(newVal, oldVal) {
        if(oldVal === 'CC' && newVal === 'DD'){
            //destroy the iFrame when switching from credit card to DD
            var copsIframe = angular.element(document.querySelector( '#copsIframe' ));
            copsIframe.remove();    
            $scope.paymentButtonDisabled = false;
        }
    });

    $scope.$watch('formData.runningTotals', function(newVal, oldVal) {
        // If the total changes we need to destroy the current cops iFrame an reload with the new ammount
        if (newVal) {                         
            $scope.hasEssentialCover = false;
            $scope.hasC4lCover = false;
            $scope.hasC4lCoverRabbit = false;

            if(typeof $scope.pet.payment !== "undefined" && $scope.pet.payment.dd.monthlyOrYearly ==='AD' && $scope.pet.payment.annualPaymentMethod === 'CC'){

                if($scope.pet.payment.cc && typeof $scope.pet.payment.cc.accountHolderNameCC !== 'undefined' && ($scope.pet.payment.cc.cardRegistered === 'Y' || ($scope.pet.payment.cc.cardRegistered ==='N' && typeof $scope.pet.payment.cc.houseNameOrNumberCC !== 'undefined' && typeof $scope.pet.payment.cc.postcodeCC !== 'undefined'))){
                    var copsIframe = angular.element(document.querySelector( '#copsIframe' ));
                    copsIframe.remove();
                    // update the cops iframe
                        formService.postCopsPayment($scope.pet.payment.cc.cardRegistered,$scope.formData.aboutYou,$scope.pet.payment.cc.accountHolderNameCC,$scope.pet.payment.cc.houseNameOrNumberCC,$scope.pet.payment.cc.postcodeCC, newVal.total).then(function success(data, status) {
                    $scope.cops = $sce.trustAsHtml(data.data.htmlpage);
                    $scope.$apply();
                    $rootScope.$broadcast('cops-loaded');

                    }, function error(data) {
                        $scope.paymentButtonDisabled = false;
                        $scope.copsErrorPop = true;
                        $scope.copsError = "C";
                        $scope.$apply();
                    });
                }
            }
        }
    });

    $scope.checkCharity = function () {
        if($window.__env.tt_cd2 && $scope.formData.charitableDonation === undefined){
            $scope.pet.payment.noCharity = true;
            $scope.formData.charitableDonation = {hasDonationSelected: 'N'};
            scrollToPoint.scrollTo('wishToDonate',20,'id');                                                                                                                              

        }
    };

    function processPayment(ptype) {
        // TODO - remove hard coded bank name
        $scope.pet.payment.dd.paymentDateAndTime = moment().format('YYYY-MM-DD[T]HH:mm:ss[Z]');
        if (ptype === 'CC') {
        
                $scope.paymentButtonDisabled = true;
                formService.postCopsPayment($scope.pet.payment.cc.cardRegistered,$scope.formData.aboutYou,$scope.pet.payment.cc.accountHolderNameCC,$scope.pet.payment.cc.houseNameOrNumberCC,$scope.pet.payment.cc.postcodeCC,$scope.formData.totals.total).then(function success(data, status) {
                    $scope.cops = $sce.trustAsHtml(data.data.htmlpage);
                    $scope.$apply();
                    $rootScope.$broadcast('cops-loaded');

                }, function error(data) {
                    $scope.paymentButtonDisabled = false;
                    $scope.copsErrorPop = true;
                    $scope.copsError = "C";
                    $scope.$apply();
                });


        }
        else {
            loadingInterceptor.incrementRequests();
            formService.postPayment($scope.pet.payment.dd, $scope.insuranceApplicationUri).then(function success(data, status) {
                // Handle the response from the IFS here
                loadingInterceptor.decrementRequests();
                goToConfirmation();
            }, function error(e) {
                errorHandler.reportErrors(e,'redirect','bank');
            });
        }
    }
    $scope.validateBank = function(e) {
        e.preventDefault();
        postBankCheck();
    };

    $scope.gotoProduct = function (product,speed,type) {

        $timeout(function () {
            scrollToPoint.scrollTo(product,speed,type);
        }, 0, false);

    };

    $scope.noToAllQuestions = function(pet) {
        return pet.extraQuestions && pet.extraQuestions.beenInsuredBefore === "N" && ( pet.extraQuestions.everSeenByVet === "N" || pet.extraQuestions.everSeenByVet === "Y" && pet.extraQuestions.everSeenByVetInnocous === "Y" ) && pet.extraQuestions.signsOfIllnessOrInjuryUwq === 'N';
    };

    $scope.postCharitableDonation = function() {
        loadingInterceptor.incrementRequests();
        formService.postCharitableDonation(formData.charitableDonation).then(function success() {
            loadingInterceptor.decrementRequests();
            // get application and set product prices per pet
            $scope.$broadcast('updateSummary');  
        }, function failure(e) {
            errorHandler.reportErrors(e,'redirect','tech');
        });
    };

    function goToConfirmation() {
        formService.postPurchased();
        if(sessionStorage.getItem('eQuote')){
            $state.go('step-6e', { forward: true });
        } else if (sessionStorage.getItem('eCoverNote')) {
            $state.go('confirm-ec', { forward: true });
        }
        else{
            $state.go('step-6', { forward: true });
        }
    }


    function postBankCheck() {
        $scope.loading = true;
        formService.postBankCheck($scope.pet.payment.dd).then(function success(data, status) {
            $scope.loading = false;

            if (data.data.status === 'valid') {
                $scope.pet.payment.valid = true;
                $scope.pet.payment.dd.bankName = data.data.bankName;
                $scope.pet.payment.dd.hash = data.data.hash;
                // scrollToPoint.scrollTo('ddSuccess',20,'id');
                $scope.pushPet();
                $scope.submit();
                return;
            } 
            if (data.data.status === 'invalid') {
                $scope.pet.payment.valid = false;
                $scope.bankLookupError = true;
                $scope.bankLookupErrorType = 'invalid';
            }
            if(data.data.status === 'failed'){
                $scope.pet.payment.valid = false;
                $scope.bankLookupError = true;
                $scope.bankLookupErrorType = 'failed';
            }

            $scope.$apply();

            //Accessibility - focus in modal window
            var modalMain = document.getElementById('bankCheckModal'),
            p = document.getElementById('skipnav'),
            modal = document.querySelector('#bankCheckModal .modal-dialog'),
            closeModalButton = document.querySelector('#bankCheckModal .modal-close'),
            returnQuote = document.querySelector('#bankCheckModal .return-quote'),
            payDetails = document.getElementById('accountHolderName'); 

            swap();  
            focusDialog(); 

            function closeDialog() {
                angular.element(modalMain).attr({'aria-hidden': 'true','tab-index': '-1','open': false}); 
                payDetails.focus();
            }                                                      
            function focusDialog(){  
                angular.element(modalMain).attr({ 'aria-hidden': 'false','tab-index': '0','open': true});  

                modal.focus();

                angular.element(closeModalButton).on('keydown', function(e){
                    if ((e.which === 9 && !e.shiftKey)) {
                        e.preventDefault();
                        modal.focus();
                    }
                });

                angular.element(modal).on('keydown', function(e){
                    if ((e.which === 9 && e.shiftKey)) {
                        e.preventDefault();        
                        closeModalButton.focus();
                    }
                }); 
            }                                       

            function swap(){
                p.parentNode.insertBefore(modalMain, p);
            } 
            //end of accessibility

            scrollToPoint.scrollTo('ddValid',20,'id');

        }, function error(data) {
            $scope.loading = false;
            if (data.status === 503) {
                $scope.pet.payment.valid = false;
                $scope.bankLookupError = true;
                $scope.bankLookupErrorType = 'failed';
                $scope.$apply();
            } else {
                errorHandler.reportErrors(data,'redirect','bank');
            }
        });
    }
    

}]);
})(window, window.angular);